/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/8
 */
import {combineReducers} from 'redux';
import {SWITCH_PAGE, ADD_DIALOG, DESTROY_DIALOG, SET_IS_LOADING} from '../actions/app';

const initState = {
  navigation: {
    list: ['选择机型', '在线估值', '填写联系人', '成功提交回购单']
  },
  dialog: [],
  isLoading: false
};

export const navigation = (state = initState.navigation, action) => {
  switch (action.type) {
    case SWITCH_PAGE:
      state.action = action.page;
      return {...state};
    default :
      return state;
  }
};

export const dialog = (state = initState.dialog, action) => {
  switch (action.type) {
    case ADD_DIALOG:
      // state.push(action.data);
      // return [...state];
      return [action.data];
    case DESTROY_DIALOG:
      return state.filter(item => item.id !== action.id);
    default:
      return state;
  }
}

export const isLoading = (state = initState.isLoading, action) => {
  switch (action.type) {
    case SET_IS_LOADING:
      return action.isLoading;
    default:
      return state;
  }
}

export default combineReducers({
  navigation,
  dialog,
  isLoading
});



// WEBPACK FOOTER //
// ./src/reducers/app.js